import qs from "qs";

// Action Types
export const LIST = "bontempo/gastronomyTypes/LIST";
export const LIST_SUCCESS = "bontempo/gastronomyTypes/LIST_SUCCESS";
export const LIST_FAIL = "bontempo/gastronomyTypes/LIST_FAIL";

export const LIST_ITEMS = "bontempo/gastronomyTypes/LIST_ITEMS";
export const LIST_ITEMS_SUCCESS = "bontempo/gastronomyTypes/LIST_ITEMS_SUCCESS";
export const LIST_ITEMS_FAIL = "bontempo/gastronomyTypes/LIST_ITEMS_FAIL";

export const DETAILS = "bontempo/gastronomyTypes/DETAILS";
export const DETAILS_SUCCESS = "bontempo/gastronomyTypes/DETAILS_SUCCESS";
export const DETAILS_FAIL = "bontempo/gastronomyTypes/DETAILS_FAIL";

export const SAVE = "bontempo/gastronomyTypes/SAVE";
export const SAVE_SUCCESS = "bontempo/gastronomyTypes/SAVE_SUCCESS";
export const SAVE_FAIL = "bontempo/gastronomyTypes/SAVE_FAIL";

export const DELETE = "bontempo/clothingCategories/DELETE";
export const DELETE_SUCCESS = "bontempo/clothingCategories/DELETE_SUCCESS";
export const DELETE_FAIL = "bontempo/clothingCategories/DELETE_FAIL";

// Reducer
const initialState = {
  data: null,
  details: null,
  gastronomyItems: [],
  loading: false,
  module: "gastronomia/categorias",
  total: 0
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LIST:
      return { ...state, loading: true };
    case LIST_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    case LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: "Não foi possível completar a requisição."
      };

    case LIST_ITEMS:
      return { ...state, loading: true };
    case LIST_ITEMS_SUCCESS:
      return {
        ...state,
        gastronomyItems: action.payload.data,
        loading: false
      };
    case LIST_ITEMS_FAIL:
      return {
        ...state,
        loading: false,
        error: "Não foi possível completar a requisição."
      };

    case DETAILS:
      return { ...state, loading: true };
    case DETAILS_SUCCESS:
      let details = action.payload.data;

      if (details.items) {
        details.items = details.items.map(item => {
          return item.id;
        });
      }

      return {
        ...state,
        details,
        loading: false
      };
    case DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: "Não foi possível completar a requisição."
      };

    case SAVE:
      return { ...state, loading: true };
    case SAVE_SUCCESS:
    case SAVE_FAIL:
      return { ...state, loading: false };

    case DELETE:
      return { ...state, loading: true };
    case DELETE_SUCCESS:
    case DELETE_FAIL:
      return { ...state, loading: false };

    default:
      return state;
  }
}

// Action Creators
export function get(params) {
  return {
    type: LIST,
    payload: {
      request: {
        url: `/gastronomy/types?${qs.stringify(params)}`
      }
    }
  };
}

export function getGastronomyItems() {
  return {
    type: LIST_ITEMS,
    payload: {
      request: {
        url: `/gastronomy/items`
      }
    }
  };
}

export function getDetails(id) {
  return {
    type: DETAILS,
    payload: {
      request: {
        url: `/gastronomy/types/${id}`
      }
    }
  };
}

export function add(data) {
  return {
    type: SAVE,
    payload: {
      request: {
        url: `/gastronomy/types`,
        method: "post",
        data: data
      }
    }
  };
}

export function edit(data, id) {
  return {
    type: SAVE,
    payload: {
      request: {
        url: `/gastronomy/types/${id}`,
        method: "put",
        data: data
      }
    }
  };
}

export function remove(id) {
  return {
    type: DELETE,
    payload: {
      request: {
        url: `/gastronomy/types/${id}`,
        method: "delete"
      }
    }
  };
}
